import { render, staticRenderFns } from "./BadgeFinanceDocumentStatus.vue?vue&type=template&id=f6bec608"
import script from "./BadgeFinanceDocumentStatus.vue?vue&type=script&lang=js"
export * from "./BadgeFinanceDocumentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports